import { render } from "./MainPettyCashReport.vue?vue&type=template&id=fb8e9434"
import script from "./MainPettyCashReport.vue?vue&type=script&lang=js"
export * from "./MainPettyCashReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__